module.exports = __webpack_public_path__ + "static/media/CRI.d38dcdae.svg";